// wec events
export const AEM_MODE_CHANGE = "wec-aem-mode-change";
export const IMAGE_LOAD = "wec-image-load";
export const PAGINATION_CHANGED = "wec-pagination-changed";
export const TAB_CHANGED_EVENT = "wec-tab-changed";
export const FILTER_CHANGED = "wec-filter-changed";
export const CATEGORY_CHANGED = "wec-category-changed";
export const COMPONENT_RESET = "wec-component-reset";
export const EVENT_AEM_MODE_CHANGE = "wec-aem-mode-changed";
export const MAP_LOADED_EVENT = "wec-map-loaded";
export const OVERLAY_CLOSED = "wec-overlay-closed";
export const STATE_CHANGED = "wec-state-changed";
export const MAP_ACTIVE_MARKER_CHANGED_EVENT = "wec-active-marker-changed";

// Form Events
export const CHECKED_EVENT = "wec-form-field-checked";
export const CHANGED_EVENT = "wec-form-field-changed";
export const SELECTION_CHANGED_EVENT = "wec-form-field-checked";
export const SEARCH_INPUT_SUBMIT_EVENT = "wec-search-input-submit";

// Consent Events
export const CONSENT_CATEGORY_CHANGED_EVENT = "wec-consent-category-changed";
export const CONSENT_MANAGEMENT_READY_EVENT = "wec-consent-management-ready";

export interface ConsentCategoryChangedEvent {
  detail: {
    category: string;
    consent: boolean;
  };
}

export const COOKIE_CHANGE_EVENT = "wec-cookie-change";
